@import './styles/tokens.css';

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --color-base: #f8fafc;
  --color-surface: #ffffff;
  --color-surface-raised: #f1f5f9;
  --color-surface-hover: #e2e8f0;
  --color-surface-dim: #f1f5f9;
  --color-divider-subtle: #e2e8f0;
  --color-divider: #cbd5e1;
  --color-text-primary: #1e293b;
  --color-text-secondary: #475569;
  --color-text-muted: #64748b;
  --color-text-faint: #94a3b8;
  --color-scrollbar-track: #f1f5f9;
  --color-scrollbar-thumb: #cbd5e1;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --color-base: #0f172a;
    --color-surface: #1e293b;
    --color-surface-raised: #273549;
    --color-surface-hover: #334155;
    --color-surface-dim: #0f172a;
    --color-divider-subtle: #1e293b;
    --color-divider: #334155;
    --color-text-primary: #f1f5f9;
    --color-text-secondary: #94a3b8;
    --color-text-muted: #64748b;
    --color-text-faint: #475569;
    --color-scrollbar-track: #1e293b;
    --color-scrollbar-thumb: #475569;
  }
}

body {
  background-color: var(--color-base);
  color: var(--color-text-primary);
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

::-webkit-scrollbar { width: 4px; }
::-webkit-scrollbar-track { background: var(--color-scrollbar-track); }
::-webkit-scrollbar-thumb { background: var(--color-scrollbar-thumb); border-radius: 2px; }
